<template>
	<div
		class="d-grid gap-3 mt-3 mb-3"
		id="comments">
		<div
			class="bg-white"
			v-if="canAddComment">
			<form @submit.prevent="addComment">
				<label
					for="comment"
					class="form-label"
					>Comment
				</label>
				<textarea-input
					name="comment"
					type="text"
					v-model="comment.content"
					:error="errors.content" />

				<div class="mt-3 d-grid gap-2 d-md-flex justify-content-md-end">
					<button
						class="btn btn-primary"
						type="submit">
						Add
					</button>
				</div>
			</form>
		</div>
		<div
			class="p-2 mb-3 bg-light border"
			v-for="item in auditCommentStore.items.data"
			:key="item.id">
			<strong>{{ item.createdBy }}</strong> - {{ item.createdOn }}
			<div>{{ item.content }}</div>
		</div>
		<loading-spinner
			:show-loading="auditCommentStore.loading"></loading-spinner>
	</div>
</template>
<script lang="ts" setup>
import {useAuditCommentStore} from "@/stores/auditCommentStore";
import {computed, ref} from "vue";
import {object, string} from "yup";
import TextareaInput from "../Fields/TextareaInput.vue";
import LoadingSpinner from "../Misc/LoadingSpinner.vue";
import {Audit, AuditComment, FormValidation} from "@/audit.types";
import {debounce} from "vue-debounce";

var updateData = debounce(() => getData(), "15000ms");

const props = defineProps<{
	id: number;
	audit: Audit;
	runAudits: boolean;
	createAudits: boolean;
}>();

const errors = ref<FormValidation>({} as FormValidation);
const canAddComment = computed(() => props.audit.status != "Closed");
const auditCommentStore = useAuditCommentStore();

const getData = async function () {
	await auditCommentStore.list(props.id);
	await updateData();
};
const comment = ref({} as AuditComment);

const schema = object<AuditComment>({
	content: string().required().label("Comment"),
});

const addComment = async function () {
	errors.value = {} as FormValidation;

	schema
		.validate(comment.value, {abortEarly: false})
		.then(async () => {
			comment.value.auditId = props.id;
			await auditCommentStore.create(comment.value);
			await auditCommentStore.list(props.id);
			comment.value = {} as AuditComment;
		})
		.catch((err) => {
			err.inner.forEach((error) => {
				errors.value = {...errors.value, [error.path]: error.message};
			});
		});
};

await getData();
</script>
